import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';
import { DeleteHardCopyDTO } from '../models/delete-hardcopy-activity-DTO';
import { HardcopyActivityCreate } from '../models/hardcopy-activity-create';
import { HardcopyActivityUpdate } from '../models/hardcopy-activity-update';
import { UpdateHardcopyActivityDTO } from '../models/update-hardcopy-activity-DTO';
import { IEQMSScopeLookUpDetails } from '../../shared/models/scopes/eqms-Scope-lookup-details';
import { DocumentLibraryConstants } from '../../../app/document/document-library-constants';
import { PhaseValueConstants } from '../../../app/shared/constants/phaseValues-constants';
import { DocumentService } from '../../../app/document/services/document.service';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class HardCopyActivityService {

  constructor(private httpClient: HttpClient, private documentsservice: DocumentService,
      private messageService: MessageService) { }

  hardcopyActivityDeleted = new Subject<boolean>();

  hardcopyActivityCompleted = new Subject<boolean>();

  hardcopyActivityCreatedOrEdited= new Subject<boolean>();

  fileId!: string;

  fileName!: string;

  createHardCopyActivity(HardCopyActivity:HardcopyActivityCreate):Observable<any>{

    return this.httpClient.post(ApiConstants.HardCopyActivity_Api,HardCopyActivity);
  }

  public OnHardcopyActivityDelete(): Observable<boolean> {
    return this.hardcopyActivityDeleted.asObservable();
}
public OnHardcopyActivityComplted(): Observable<boolean> {
  return this.hardcopyActivityCompleted.asObservable();
}

public OnHardcopyActivityCreatedOrEdited(): Observable<boolean> {
  return this.hardcopyActivityCreatedOrEdited.asObservable();
}

  updateHardCopyActivityForEdit(hardcopyActivityID:any,HardCopyActivity:HardcopyActivityUpdate):Observable<any>{
    return this.httpClient.post(ApiConstants.HardCopyActivity_Api + '/' + `${hardcopyActivityID}`,HardCopyActivity);
  }

  getHardCopyActivities(docNumber:string,docVersion:number):Observable<any>{
    return this.httpClient.get(ApiConstants.HardCopyActivity_Api,{
      params:{
        docNumber:docNumber,
        docVersion:docVersion
      }
    });
  }
  updateHardcopyActivity(hardcopyActivityID:any,updateHardcopyData:UpdateHardcopyActivityDTO):Observable<any>{
    return this.httpClient.put(ApiConstants.HardCopyActivity_Api+ '/' + `${hardcopyActivityID}` , updateHardcopyData);
  }
  deleteHardcopyActivity(hardcopyActivityID:any,deleteHardcopyData:DeleteHardCopyDTO):Observable<any>{
    return this.httpClient.delete(ApiConstants.HardCopyActivity_Api+ '/' + `${hardcopyActivityID}`,{body:deleteHardcopyData});
  }

  getHardCopyActivityForId(hardcopyActivityID:any):Observable<any>{
    return this.httpClient.get(ApiConstants.HardCopyActivity_Api+ '/' +`${hardcopyActivityID}`);
  }

  geteQMSScopesForHardCopyActivity = (documentNumber:string,documentVersion:string)
  : Observable<IEQMSScopeLookUpDetails[]> => {
    return this.httpClient.get<IEQMSScopeLookUpDetails[]>
    (ApiConstants.EQMSScopesForHardCopyActivity_Api
      .replace('{documentNumber}',documentNumber).replace('{documentVersion}',documentVersion));
    
  }


  ///Method to get document source file and download it
   getAndDownloadDocumentSourceFile(documentNumber: any, documentVersion: any, documentPhase: any, documentIncludesClientSignature: any) {
      if (documentPhase === PhaseValueConstants.Collaboration || 
          documentPhase === PhaseValueConstants.QaReview || 
          documentPhase === PhaseValueConstants.Formatting) {
    
        this.documentsservice
          .getDocumentSourceFile(documentNumber, documentVersion)
          .subscribe({
            next: (documentSourceFile) => {
              this.fileId = documentSourceFile.fileId;
              this.fileName = documentSourceFile.name;
              this.downloadSourceFile(this.fileId, this.fileName, documentPhase); 
            },
            error: (error) => {
              if (error.status === 401) {
                this.messageService.add({
                  severity: DocumentLibraryConstants.Severity_Err,
                  summary: `${error.error}`,
                });
              } else if (documentPhase === PhaseValueConstants.Collaboration) {
                this.messageService.add({
                  severity: DocumentLibraryConstants.Severity_Err,
                  summary: DocumentLibraryConstants.DocumentSourceFile_Creation_Failed,
                  sticky: true
                });
              }
            }
          });
    
      } else if (documentPhase !== PhaseValueConstants.Cancelled) {
        this.documentsservice
          .getDocumentDetailsForDocumentFormattedFile(documentNumber, documentVersion)
          .subscribe({
            next: (documentFormattedFile) => {
              this.fileId = documentFormattedFile.fileId;
              this.fileName = documentFormattedFile.name;
              this.downloadSourceFile(this.fileId, this.fileName, documentPhase);
            },
            error: (error) => {
              if (error.status === 401) {
                this.messageService.add({
                  severity: DocumentLibraryConstants.Severity_Err,
                  summary: `${error.error}`,
                });
              } else if (
                (documentIncludesClientSignature && documentPhase === PhaseValueConstants.ClientSignature) ||
                (!documentIncludesClientSignature && documentPhase === PhaseValueConstants.InReview)
              ) {
                this.messageService.add({
                  severity: DocumentLibraryConstants.Severity_Err,
                  summary: DocumentLibraryConstants.File_Generation_Failed,
                  sticky: true
                });
              }
            }
          });
      }
    }
    
      
  ///Method to download document source file
    downloadSourceFile = (fileId: string, fileName: string,documentPhase:number) => {
          let formatedFileGenerationPhase = false;
          if (documentPhase === PhaseValueConstants.InReview
            || documentPhase === PhaseValueConstants.Approved
            || documentPhase === PhaseValueConstants.Effective
            || documentPhase === PhaseValueConstants.ClientSignature) 
            { 
              formatedFileGenerationPhase = true;
            }
          if (formatedFileGenerationPhase == true) {
          setTimeout(() => {
            this.messageService.add({
              severity: DocumentLibraryConstants.Severity_Info,
              summary:  DocumentLibraryConstants.Document_File_Availability_Status_Information
            })
          }, 50);
        }
      
           this.documentsservice.downloadFile(fileId).subscribe({
            next:(response) => {
              if (formatedFileGenerationPhase == true) {
              this.messageService.clear();
              }
             const fileUrl = response.fileUri;
             let downloadLink = document.createElement('a');
             document.body.appendChild(downloadLink);
             downloadLink.setAttribute('style', 'display: none');
             downloadLink.href = fileUrl;
             downloadLink.download = fileName;
             downloadLink.target = '_blank';
             downloadLink.click();
             downloadLink.remove();
            },
            error:()=>{
              if (formatedFileGenerationPhase == true) {
                this.messageService.clear();
                }
              if(fileId != undefined || fileId != null){
                this.messageService.add({
                  severity: DocumentLibraryConstants.Severity_Err,
                  summary: DocumentLibraryConstants.Document_File_UnableToDownload,
                  sticky: true
                })
              }
              else{
                this.messageService.add({
                  severity: DocumentLibraryConstants.Severity_Err,
                  summary: DocumentLibraryConstants.Document_File_NotAvailableToDownload,
                  sticky: true
                })
              }
            }
          });
        }
}

